import React, { useEffect, useState } from "react";
import KPIStat from "../../components/common/KPIStat/KPIStat";
import baseServices from "../../services/base.services";
import "../Diario/Progress-Diario.css";
import DiarioDataToObject from "./Diario-data-to-object";
import SerieC from "./Diario-Serie-C";
import "../Diario/Diario.css";
import Servidores from "./Diario-servidores";
import Scada from "./Diario-Scada";
import Red from "./Diario-Red";
import PCDI from "./Diario-PCDI";

export default function ProgressDiario({ body, site }) {
  const [percent, setPercent] = useState([]);

  const URL = "getReporteDiarioV0";

  useEffect(() => {
    const getData = async () => {
      try {
        if (body) {
          var response = await baseServices.getDataN2(
            { Site: site, esTest: 0 },
            URL
          );
          if (response.data && response.data.length > 0) {
            //dispatch(startLineChart(response.data[0]))
            setPercent(DiarioDataToObject(response));
            setTimeout(() => {
              getData();
            }, 100000);
          }
        } else {
          setPercent(DiarioDataToObject());

          setTimeout(() => {
            getData();
          }, 100000);
        }
      } catch (err) {
        setTimeout(() => {
          getData();
        }, 100000);
      }
    };

    getData();
  }, []);

  let titleCard = site.toUpperCase();

  if (site.toUpperCase() === "DMH") {
    titleCard = "MINISTRO HALES";
  }

  return (
    <>
      <div id="container-colum">
        <KPIStat
          url="sp_GetData"
          body={{ params: body }}
          isCard="1"
          titleCard={titleCard}
        />

        <div id="space"></div>
        <SerieC body={{ actual: percent.C300, previus: percent.C300p }} />
        <div id="space"></div>

        <Servidores
          body={{ actual: percent.SERVIDORES, previus: percent.SERVIDORESp }}
        />
        <div id="space"></div>

        <Scada body={{ actual: percent.SCADA, previus: percent.SCADAp }} />
        <div id="space"></div>

        <Red body={{ actual: percent.FTE, previus: percent.FTEp }} />
        <div id="space"></div>

        <PCDI body={{ actual: percent.PLC, previus: percent.PLCp }} />
        <div id="space"></div>
      </div>
    </>
  );
}
